var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-news-carousel"},_vm._l((_vm.posts.slice(0,3)),function(card,index){return _c('div',{key:card.id,staticClass:"blog-item"},[_c('BlogCard',{attrs:{"cat-title":card.categoria.name,"flag":card.categoria.color,"id":card.id,"img":card.file,"sidebar":true,"offset":index,"title":card.title,"desc":card.text}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }